import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getCurrencyOptions, getField, getSettings } from "@/onboarding/features/product/selectors"
import { useModal } from "@/helpers/useModal"
import FormikBootstrap from "@/components/formik-bootstrap"
import EditIcon from "./EditIcon"
import EditModal from "./EditModal"
import FormikFieldSubmitter from "./FormikFieldSubmitter"

type Props = {
  fieldName: string
  label: string
}

const Edit: FC<Props> = ({ fieldName, label }) => {
  const field = useSelector(getField(fieldName))
  const currencyOptions = useSelector(getCurrencyOptions)

  return (
    <FormikFieldSubmitter initialValues={{ [fieldName]: field.value }}>
      <FormikBootstrap.Select name={fieldName} label={label}>
        {currencyOptions.map(({ value, label: optionLabel }) => (
          <option key={value} value={value}>
            {optionLabel}
          </option>
        ))}
      </FormikBootstrap.Select>
    </FormikFieldSubmitter>
  )
}

const CurrencyPicker: FC<Props> = ({ fieldName, label }) => {
  const field = useSelector(getField(fieldName))
  const settings = useSelector(getSettings(fieldName))
  const editable = settings[fieldName]?.writeable ?? false

  const toggleModal = useModal((props) => (
    <EditModal {...props} title={label} Body={Edit} bodyProps={{ fieldName, label }} />
  ))

  // Hide when the field is absent from the document being viewed (which
  // may be a bid doc that pre-dates currency-split and hasn't been
  // back-filled). getField falls through to nullField for missing fields.
  if (field.type === "NullField") return null

  return (
    <div className="d-flex align-items-center gap-2">
      <span className="fw-bold">{label}:</span>
      <span>{field.value || "—"}</span>
      {editable && <EditIcon onEdit={toggleModal} />}
    </div>
  )
}

export default CurrencyPicker
